<template>
  <b-modal :visible="true"
           size="xl"
           ok-only
           title="Image Generation"
           @close="$emit('close')"
           @hide="$emit('close')"
  >
    <!-- <b-overlay :show="state.isQueueRunning"
               style="min-height: 150px;"
    >
      <img v-if="generatedImage"
           v-image-preview
           style="max-width: 100%;"
           :src="generatedImage"
      >
    </b-overlay>
     -->
    <stable-diffusion
      :word="word"
      @onImageGenerate="value => generatedImage = value"
    />
    <template #modal-footer>
      <template v-if="generatedImage">
        <b-button
          v-if="sourceFrom === 'cb'"
          variant="outline-success"
          class="mr-1"
          :disabled="props.isProcessing || isProcessingImage"
          @click.stop="onPick"
        >
          <b-spinner v-if="isProcessingImage"
                     small
          />
          {{ $t('image-library-module.pick') }}
        </b-button>
        <b-button
          v-else
          variant="outline-primary"
          class="mr-1"
          :disabled="props.isProcessing"
          @click="$emit('saveImage', generatedImage)"
        >
          <b-spinner v-if="props.isProcessing"
                     small
          /> Save Image
        </b-button>
      </template>
      <b-button variant="outline-secondary"
                @click="$emit('close')"
      >
        Cancel
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import {
  // eslint-disable-next-line no-unused-vars
  BModal, BButton, BSpinner,
} from 'bootstrap-vue'
import { ref } from 'vue'
import useJwt from '@/auth/jwt/useJwt'
import StableDiffusion from './index.vue'

const props = defineProps({
  word: {
    type: String,
    required: true,
  },
  isProcessing: {
    type: Boolean,
    default: false,
  },
  sourceFrom: {
    type: String,
    default: '',
  },
})
const isProcessingImage = ref(false)
const generatedImage = ref(null)

// Emits
const emit = defineEmits(['pickImage', 'saveImage', 'close'])

// Handler for picking an image
function onPick() {
  isProcessingImage.value = true
  useJwt.saveImageGenerated({
    img: generatedImage.value,
  }).then(response => {
    const imgUrl = response.data.data.response
    emit('pickImage', imgUrl)
  }).finally(() => {
    isProcessingImage.value = false
  })
}

</script>
